import React, { Component } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../css/reports/reports.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import SignalRService from "../../controllers/SignalRService";
import DataGrid, { Paging, Column, FilterRow, Pager, Lookup, StateStoring, Toolbar, Item } from 'devextreme-react/data-grid';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InteractionMessagesModal from '../misc/interactionmessagesmodal';
import ChatsService from '../../controllers/ChatController';
import { changeJanusStatus } from '../../redux/parametersSlice';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import { seconds2HMS } from '../utils/utils';
import ConversationSummary from '../chat/conversationsummary';
import InteractionMailModal from '../misc/interactionMailModal';
import Contact from '../contacts/contact';
import MailHistory from '../misc/mailhistory';

const dataSource = new DataSource({
    store: new ArrayStore({
        key: 'id',
        data: []
    }),
    reshapeOnPush: true
});

class Reports extends Component {

    constructor() {

        super();

        this.state = {
            channels: [
                { id: "FIDELITY", name: "Fidelity" },
                { id: "FACEBOOK", name: 'Facebook' },
                { id: "TWITTER", name: 'X' },
                { id: "INSTAGRAM", name: 'Instagram' },
                { id: "WHATSAPP", name: 'WhatsApp' },
                { id: "RAINBOW", name: 'Rainbow' },
                { id: "TELEGRAM", name: 'Telegram' },
                { id: "CALL", name: 'call' },
                { id: "MAIL", name: 'email' },
                { id: "GENERIC", name: 'generic' },
            ],
            callTypes: [
                { id: true, name: "outgoing" },
                { id: false, name: "incoming" }
            ],
            interaction: null,
            showInteraction: false,
            showSummary: false,
            guid: null,
            showInteractionMail: false,
            emailMessageNumber: null,
            iframeUrl: '',
            id: null,
            channel: "",
            outbound: false,
            showContactModal: false,
            bookId: null,
            showHistory: false,
            mail: null
        };

        this.getInteractions = this.getInteractions.bind(this);
        this.toggleInteraction = this.toggleInteraction.bind(this);
        this.toggleInteractionMail = this.toggleInteractionMail.bind(this)
        this.interactionClick = this.interactionClick.bind(this);
        this.phoneCell = this.phoneCell.bind(this);
        this.viewSummary = this.viewSummary.bind(this);
        this.toggleSummary = this.toggleSummary.bind(this);
        this.showSummary = this.showSummary.bind(this);
        this.viewContact = this.viewContact.bind(this);
        this.toggleContactModal = this.toggleContactModal.bind(this);
        this.toggleHistory = this.toggleHistory.bind(this);
    }

    componentDidMount() {
        this.getInteractions();
        SignalRService.registerOmniChannelInteractionsList(this.updateTable);
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.userId !== prevProps.userId) {
            this.getInteractions();
        }
    }

    updateTable(data) {
        dataSource.store().clear();
        data.forEach((v, i) => {
            v.startDate = new Date(v.startDate);
            dataSource.store().push([{ type: 'insert', data: v }]);
        });
    }

    getInteractions = async () => {
        SignalRService.getOmniChannelInteractions({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "filterByUser": true
        });
    }

    channelCell = dataCell => {
        return (<>
            {
                (dataCell.data.chatGuid) &&
                <div onClick={e => this.interactionClick(dataCell.data.chatGuid)} className={`icon ${dataCell.value.toLowerCase()}`} style={{ "left": "20px", cursor: "pointer" }} ></div>
            }
            {
                (!dataCell.data.chatGuid) &&
                <div className={`icon ${dataCell.value.toLowerCase()}`} style={{ "left": "20px" }} ></div>
            }
        </>)
    }

    typeCell = dataCell => {
        return (<div className={`${!dataCell.value ? 'text-success' : 'text-primary'} text-center`}  >
            {
                (dataCell.value) &&
                <FontAwesomeIcon className='primary' size='2x' icon={duotone('arrow-up-right')} />
            }
            {
                (!dataCell.value) &&
                <FontAwesomeIcon className='success' size='2x' icon={duotone('arrow-down-left')} />
            }
        </div>
        )
    }

    nameCell = dataCell => {
        return (
            <span className={""}>{dataCell.value}</span>
        )
    }

    emailCell = dataCell => {
        return (
            (dataCell.value) &&
            <a className={""} href={`mailto:${dataCell.value}`}>{dataCell.value}</a>
        )
    }

    phoneCell = dataCell => {
        return (
            (dataCell.value) &&
            <a className={""} href="/#" onClick={(e) => {
                e.preventDefault();
                this.props.changeJanusStatus("makeCall");
                SignalRService.makeCall({
                    "extension": this.props.extension,
                    "userId": this.props.userId,
                    "called": dataCell.value
                });
            }}>{dataCell.value}</a>
        )
    }

    groupCell = dataCell => {
        return (
            (dataCell.value) &&
            <span className={""}>{dataCell.value}</span>
        )
    }

    viewChatCell = dataCell => {
        if (dataCell.data.channel === "MAIL") {
            return (
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("viewContent")}
                    </Tooltip>}>
                    <Button variant="light-primary" size='sm'
                        onClick={e => { console.log(dataCell); this.interactionMailClick(dataCell.data.emailMessageNumber, dataCell.data.emailInbox) }}>
                        <FontAwesomeIcon icon={duotone('eye')} /></Button>
                </OverlayTrigger>
            )
        }
        else {
            return (
                (dataCell.value) &&
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("viewContent")}
                    </Tooltip>}>
                    <Button variant="light-primary" size='sm' onClick={e => { this.interactionClick(dataCell.value) }}><FontAwesomeIcon icon={duotone('eye')} /></Button>
                </OverlayTrigger>
            )
        }
    }

    interactionMailClick = (emailMessageNumber, inbox) => {
        var data = JSON.parse(localStorage.getItem("fc-logged"));
        var rcu = localStorage.getItem("faRCUser");
        var rcp = localStorage.getItem("faRCPwd");
        var roundcubeUrl = localStorage.getItem("faRC");

        var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_faagtinbox=1`

        this.setState({ emailMessageNumber: emailMessageNumber });
        this.setState({ iframeUrl: url });
        this.toggleInteractionMail();
    }

    interactionClick = (chatGuid) => {

        ChatsService.getChat(chatGuid, res => {
            this.setState({
                interaction: res.data
            });

            this.toggleInteraction();
        });
    }

    toggleInteraction = e => {
        this.setState({ showInteraction: !this.state.showInteraction });
    }

    toggleInteractionMail = e => {
        console.log("interactionMailClick");
        this.setState({ showInteractionMail: !this.state.showInteractionMail });
    }

    toggleContactModal() {
        this.setState({ showContactModal: !this.state.showContactModal });
    }

    interactionContactClick = (bookId) => {
        this.setState({ bookId: bookId });
        this.toggleContactModal();
    }

    viewContact = dataCell => {
        return (
            (dataCell.data && dataCell.data.bookId) &&
            <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {this.props.t("contact")}
                </Tooltip>}>
                <Button variant="light-primary" size='sm' onClick={e => this.interactionContactClick(dataCell.data.bookId)}><FontAwesomeIcon icon={duotone('address-book')} /></Button>
            </OverlayTrigger>
        )
    }

    // //!DOESNT WORK WITH REACTJS...
    // channelItemTemplate = (itemData, itemIndex, itemElement) => {

    //     var div = document.createElement("div");

    //     if (itemData) {
    //         div.classList.add('icon');
    //         div.classList.add(itemData.id.toLowerCase());
    //         div.style.left = "20px";
    //     }

    //     return div;

    // }

    // overrideOnValueChanged = (e) => {
    //     if (e.dataField === "channel") {
    //         e.editorOptions.itemTemplate = this.channelItemTemplate
    //     }        
    // }

    missedCell = dataCell => {
        return (
            <div className={`${dataCell.value ? 'text-danger' : 'text-primary'}`}  >
                {
                    (dataCell.value) &&
                    <FontAwesomeIcon className='danger' size='lg' icon={solid('x')} />
                }
            </div>
        )
    }

    durationCell = dataCell => {
        return (
            <div>
                {
                    seconds2HMS(dataCell.value || 0)
                }
            </div>
        )
    }

    viewSummary = dataCell => {
        return (
            dataCell.data !== undefined && dataCell.data !== null && dataCell.data.channel !== "CALL" &&
            <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {this.props.t("aisummary")}
                </Tooltip>}>
                <Button variant="light-primary" size='sm' onClick={e => this.toggleSummary(dataCell.data)}><FontAwesomeIcon icon={duotone('square-list')} /></Button>
            </OverlayTrigger>
        )
    }

    toggleSummary = data => {

        this.setState({
            guid: data.chatGuid,
            id: data.id,
            channel: data.channel,
            outbound: data.outbound
        });

        setTimeout(() => {
            this.showSummary();
        }, 50);

    }

    showSummary = () => {
        this.setState({
            showSummary: !this.state.showSummary
        });
    }

    toggleHistory = data => {
        this.setState({ showHistory: !this.state.showHistory, mail: data });
    }

    viewHistory = dataCell => {
        return (
            dataCell.data.channel === "MAIL" &&
            <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {this.props.t("emailthread")}
                </Tooltip>}>
                <Button variant="light-primary" size='sm'
                    onClick={e => { this.toggleHistory(dataCell.data) }}>
                    <FontAwesomeIcon icon={duotone('clock-rotate-left')} /></Button>
            </OverlayTrigger>
        )
    }
    render() {
        return (
            <div style={{ position: "relative", right: "10px" }}>
                <DataGrid
                    dataSource={dataSource}
                    id="interactionstable"
                    noDataText=""
                    rowAlternationEnabled={true}
                    height={"78vh"}
                    width={"100%"}
                    allowColumnResizing={true}
                // onEditorPreparing={this.overrideOnValueChanged}
                >
                    <Column dataField="id" caption={""} visible={false} />
                    <Column allowHeaderFiltering={false} cssClass={"align-middle"} dataField="channel" caption={this.props.t("channel")} width={100} cellRender={this.channelCell}>
                        <Lookup className="field-customization"
                            dataSource={this.state.channels}
                            valueExpr="id"
                            displayExpr={e => {
                                return this.props.t(e.name);
                            }}
                        />
                    </Column>
                    <Column dataField="outbound" cssClass={"align-middle"} caption={this.props.t("type")} width={100} cellRender={this.typeCell}>
                        <Lookup className="field-customization"
                            dataSource={this.state.callTypes}
                            valueExpr="id"
                            displayExpr={e => {
                                return this.props.t(e.name);
                            }}
                        />
                    </Column>
                    <Column dataField="missed" cssClass={"align-middle"} caption={this.props.t("missed2")} width={100} cellRender={this.missedCell} />
                    <Column dataField="party" caption={this.props.t("name")} width={350} cellRender={this.nameCell} />
                    <Column dataField="phone" caption={this.props.t("phone")} width={150} cellRender={this.phoneCell} />
                    <Column dataField="email" caption={this.props.t("email")} width={350} cellRender={this.emailCell} />
                    <Column dataField="groupName" caption={this.props.t("group")} width={250} cellRender={this.groupCell} />
                    <Column dataField="startDate" caption={this.props.t("datetime")} dataType="datetime" format='dd/MM/yyyy HH:mm:ss' selectedFilterOperation=">=" width={180} />
                    <Column dataField="duration" caption={this.props.t("duration")} width={100} cellRender={this.durationCell} />
                    <Column dataField="chatGuid" caption={""} width={60} cellRender={this.viewChatCell} allowFiltering={false} />
                    <Column caption={""} width={60} cellRender={this.viewSummary} allowFiltering={false} visible={this.props.aiEnabled} />
                    <Column cssClass={"align-middle"} caption={""} width={60} cellRender={this.viewContact} allowFiltering={false} />
                    <Column cssClass={"align-middle"} caption={""} width={60} cellRender={this.viewHistory} allowFiltering={false} />
                    <FilterRow visible={true} applyFilter={"auto"} showOperationChooser={false} className={"form-control"} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[5, 9, 12, 15]}
                        showInfo={true}
                        showNavigationButtons={true}
                        infoText={this.props.t("pager")}
                    />
                    <Paging defaultPageSize={12} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey={`fcReports_${this.props.userId}`}
                    />
                    <Toolbar>
                        <Item location="after" locateInMenu="auto">
                            <Button variant="light-primary" size="xs" onClick={this.getInteractions} >
                                <FontAwesomeIcon icon={solid("arrows-rotate")} />
                            </Button>
                        </Item>
                    </Toolbar>
                </DataGrid>
                <InteractionMailModal show={this.state.showInteractionMail} toggleModal={this.toggleInteractionMail} interaction={this.state.interaction} url={this.state.iframeUrl}></InteractionMailModal>
                <InteractionMessagesModal show={this.state.showInteraction} toggleModal={this.toggleInteraction} interaction={this.state.interaction}></InteractionMessagesModal>
                <ConversationSummary show={this.state.showSummary} toggleModal={this.toggleSummary} guid={this.state.guid != null ? this.state.guid : -1} id={this.state.id} channel={this.state.channel} outbound={this.state.outbound}></ConversationSummary>
                <Contact show={this.state.showContactModal} toggleModal={this.toggleContactModal} action="editcontact" contactId={this.state.bookId}></Contact>
                <MailHistory show={this.state.showHistory} toggleModal={this.toggleHistory} mail={this.state.mail}></MailHistory>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        aiEnabled: state.parameters.aiEnabled
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(Reports);